import Button from '../../../components/button';
import './styles.scss';
import { ReactComponent as ArrowLeftIcon } from '../../../assets/icons/arrow-left.svg';
import { ReactComponent as ChartFunnel } from '../../../assets/draws/funnel.svg';
import subscribeDraw from '../../../assets/draws/subscribe.png';
import checkoutDraw from '../../../assets/draws/checkout-mini.png';


export default function OnboardingSteps() {
    const steps = [
        {
            title: "Atração de audiência nas redes sociais",
            subtitle: "Divulgue o link da sua comunidade para quem consome seus conteúdos."
        },
        {
            title: 'Inscrição na sua comunidade',
            subtitle: 'Os visitantes se transformam em inscritos na sua plataforma no Ginastee.',
            bottom: <img src={subscribeDraw} alt="Subscribe Draw" className="step-bottom"/>
        },
        {
            title: 'Pagamento de assinatura',
            subtitle: 'Seus inscritos pagam o valor definido por você para acessar seus conteúdos premium.',
            bottom: <img src={checkoutDraw} alt="Checkout Draw" className="step-bottom"/>
        },
    ]

    return (
        <div className="onboarding-steps mt-6">
            <div className="container">
                <h1>O funil de vendas ideal para maximizar a sua receita</h1>
                <h4 className="pb-2" style={{ opacity: 0.7, width: '70%' }}>Projetado nos minimos detalhes para profissionais da saúde transformarem escalarem seu faturamento</h4>
                <Button.Large
                    text="Criar minha comunidade agora"
                    rightIcon={<ArrowLeftIcon />}
                    onClick={window.config.redirects.openApp}
                />
            </div>
            <div className="steps mt-4">
                {
                    steps.map((step, index) => (
                        <Step key={index} index={index + 1} step={step} />
                    ))
                }

                <ChartFunnel className="chart-funnel" />
            </div>
        </div>
    );
}

function Step({ index, step }) {
    return (
        <div className="step">
            <h3 className="step-number">0{index}</h3>
            <h3 className="step-title mt-1 mb-1">{step.title}</h3>
            <span className="step-subtitle">{step.subtitle}</span>
            {step.bottom}
        </div>
    )
}